import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Chapter } from "../components/Chapter";
import { Reveal, MaskedLine } from "../lib/motion";
import { usePageSeo } from "../lib/i18nContext";
import EnquiryForm, { CATEGORIES } from "../components/EnquiryForm";
import { CONTACT_EMAIL } from "../components/Footer";

const WRAP = "max-w-[1240px] mx-auto px-6 md:px-12 xl:px-16";

const Contact = () => {
  usePageSeo("contact");
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const cat = params.get("category") || "";
  const defaultCategory = CATEGORIES.includes(cat) ? cat : "";
  const defaultDestination = params.get("destination") || "";
  const rows = t("contactPage.reach.rows", { returnObjects: true });
  const emailLabel = Array.isArray(rows) ? rows[1] : t("footer.contactLabels.email");

  return (
    <main className="pt-nav">
      <section data-testid="contact-hero" className="bg-white border-b border-ice">
        <div className={`${WRAP} py-16 md:py-24`}>
          <p className="font-mono text-xs md:text-[13px] font-medium tracking-[0.18em] uppercase text-pine mb-8">{t("contactPage.eyebrow")}</p>
          <h1 className="font-display font-semibold text-ink text-[36px] md:text-[44px] tracking-tight leading-[1.12] max-w-4xl" data-testid="contact-headline">
            <MaskedLine delay={0.1}>{t("contactPage.line1")}</MaskedLine>
            <MaskedLine delay={0.2}>{t("contactPage.line2")}</MaskedLine>
          </h1>
          <p className="text-slate leading-relaxed mt-8 max-w-2xl text-base md:text-lg">{t("contactPage.intro")}</p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className={`${WRAP} grid grid-cols-1 lg:grid-cols-12 gap-16`}>
          <div className="lg:col-span-4">
            <Chapter index="01" label={t("contactPage.reach.chapter")} />
            <Reveal delay={0.05}>
              <div className="mt-10 border-t border-b border-ice py-6" data-testid="contact-email-row">
                <p className="font-mono text-xs font-medium tracking-[0.18em] uppercase text-slate">{emailLabel}</p>
                <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-link" className="inline-block mt-3 text-lg font-semibold text-ink underline decoration-pine decoration-2 underline-offset-[6px] hover:text-pine transition-colors" dir="ltr">
                  {CONTACT_EMAIL}
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Chapter index="02" label={t("contactPage.enquiry.chapter")} />
            <Reveal delay={0.05}>
              <h2 className="font-display text-[26px] md:text-[32px] font-semibold tracking-tight text-ink leading-tight mt-8 mb-12">{t("contactPage.enquiry.heading")}</h2>
            </Reveal>
            <EnquiryForm defaultCategory={defaultCategory} defaultDestination={defaultDestination} />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
